export enum CampaignTypes {
	CPA = 'CPA',
	CPM = 'CPM',
}

export type CampaignType = CampaignTypes.CPA | CampaignTypes.CPM;
